<template>
	<div>
		<div class="mb-3">
			When you set Navigation Menu, the menu will display product categories based on the levels you define.
		</div>

		<CRow class="m-0">
			<CButton
				class="transparent"
				color="secondary"
				data-test-id="add-banner"
				@click="handleAdd"
			>
				<CIcon class="mr-2" name="cil-plus" />{{ previewList.length ? 'Edit' : 'Add' }} Navigation Menu
			</CButton>
		</CRow>

		<div
			v-if="previewList.length"
			class="border border-gray-400 rounded mt-4 items-container"
		>
			<div
				v-for="item in previewList"
				:key="item.id"
			>
				<CategoryNavigationMenuItem
					class="p-2"
					:navigation-menu-item="item"
					:is-displaying="item.isDisplaying"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import CategoryNavigationMenuItem from '@/components/CategoryNavigationMenuItem.vue';

import { PERIOD_STATUSES } from '../enums/status';

export default {
	name: 'CategoryNavigationMenu',

	components: {
		CategoryNavigationMenuItem,
	},
	props: {
		navigationMenuItems: {
			type: Array,
			default: () => [],
		},
	},

	data() {
		return {
			list: this.navigationMenuItems,
		};
	},

	computed: {
		previewList() {
			let isSetDisplaying = false;
			const localList = [];
			this.list.forEach((item) => {
				const isDisplaying = !isSetDisplaying
					&& item.isActive
					&& item.period === PERIOD_STATUSES.ON_GOING;
				if (isDisplaying) {
					isSetDisplaying = true;
				}
				localList.push({
					...item,
					isDisplaying,
				});
			});
			return localList;
		},
	},

	watch: {
		navigationMenuItems(newValue) {
			this.list = newValue;
		},
	},

	methods: {
		handleAdd() {
			this.$emit('onClickAdd');
		},
	},
};
</script>

<style lang="scss" scoped>
.items-container {
	> *:not(:last-child) {
		border-bottom: 1px solid $color-gray-400;
	}
}
</style>